import React from "react";
import styles from "./styles.module.css";
import { connect } from "react-redux";
import { setBranchId } from "../../../auth/actions";
import PropTypes from "prop-types";
import { Dropdown } from "../../../../common/ui";
import CurrentStockDetailsSection from "./CurrentStockDetailsSection";

const Stats = ({ setBranchId, auth: { branchList, branchId } }) => {
  const branchOptions = (branchList || []).map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const handleChangeBranch = (value) => {
    setBranchId(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <h1 className={styles.pageTitle}>Stats</h1>
        </div>
        {branchId != null && branchOptions.length > 0 && (
          <div className={styles.branchWrap}>
            <Dropdown
              label="Branch"
              options={branchOptions}
              value={branchId}
              onChange={handleChangeBranch}
              placeholder="Select branch"
            />
          </div>
        )}
      </div>
      <div className={styles.body}>
        <CurrentStockDetailsSection />
      </div>
    </div>
  );
};

Stats.propTypes = {
  setBranchId: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    branchList: PropTypes.array,
    branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.authState,
});

export default connect(mapStateToProps, {
  setBranchId,
})(Stats);
